import React from 'react';

const StepperContext = /*#__PURE__*/React.createContext(undefined);
const StepContext = /*#__PURE__*/React.createContext(undefined);
const StepperProvider = StepperContext.Provider;
const StepProvider = StepContext.Provider;
/* eslint-disable @typescript-eslint/explicit-function-return-type */
const useStepper = _ref => {
  let {
    activeIndex = 0,
    stepsArray = [],
    variant = "linear",
    vertical = false
  } = _ref;
  return {
    activeIndex,
    stepsArray,
    variant,
    vertical
  };
};

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const useStep = _ref2 => {
  let {
    active = false,
    complete = false,
    invalid = false
  } = _ref2;
  return {
    active,
    complete,
    invalid
  };
};
const useStepperContext = () => {
  return React.useContext(StepperContext);
};
const useStepContext = () => {
  return React.useContext(StepContext);
};

export { StepProvider, StepperProvider, useStep, useStepContext, useStepper, useStepperContext };
